/* eslint max-len: 0 */
const titlesByCategory = {
  // Cualquier modificación se debe replicar en app\models\concerns\title_categories.rb
  // Anexo 30 y 31 año 2022
  // datosGenerales: [1, 2, 3, 4, 5, 6, 7],
  anexo30Y31Ano2022DatosGenerales: [1, 2, 3, 4, 5, 6, 7],
  anexo30Y31Ano2022SistemasDeMedicion: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
  anexo30Y31Ano2022SGM: [27, 28, 30, 31, 32],
  anexo30Y31Ano2022ProgramaInformatico: [36, 37, 38, 39, 40, 41, 42, 43, 44],
  anexo30Y31Ano2022EvidenciasFotograficas: [48, 49, 50, 51],
  // Anexo 30 y 31 año 2023
  anexo30Y31Ano2023DatosGenerales: [55, 56, 57, 58, 59, 60, 61],
  anexo30Y31Ano2023SistemasDeMedicion: [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77],
  anexo30Y31Ano2023SGM: [81, 82, 84, 85, 86],
  anexo30Y31Ano2023ProgramaInformatico: [90, 91, 92, 93, 94, 95, 96, 97, 98],
  anexo30Y31Ano2023EvidenciasFotograficas: [102, 103, 104, 105],
  // Anexo 30 y 31 año 2024
  anexo30Y31Ano2024DatosGenerales: [109, 110, 111, 112, 113, 114, 115, 344],
  anexo30Y31Ano2024SistemasDeMedicion: [119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131],
  anexo30Y31Ano2024SGM: [135, 136, 138, 139, 140, 141, 142, 143, 144, 145, 346],
  anexo30Y31Ano2024ProgramaInformatico: [149, 150, 151, 152, 153, 154, 155, 156, 157],
  anexo30Y31Ano2024EvidenciasFotograficas: [161, 162, 163, 164],
  anexo30Y31Ano2024Certificado: [348],

  // Anexo 30 y 31 año 2025
  anexo30Y31Ano2025DatosGenerales: [285, 286, 287, 288, 289, 290, 291, 345],
  anexo30Y31Ano2025SistemasDeMedicion: [295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307],
  anexo30Y31Ano2025SGM: [311, 312, 314, 315, 316, 317, 318, 319, 320, 321, 347],
  anexo30Y31Ano2025ProgramaInformatico: [325, 326, 327, 328, 329, 330, 331, 332, 333],
  anexo30Y31Ano2025EvidenciasFotograficas: [337, 338, 339, 340],
  anexo30Y31Ano2025Certificado: [349],

  // Anexo 21 y 22 rmf 2026
  anexo21Y22Rmf2026DatosGenerales: [350, 351, 352, 353, 354, 355, 356, 511],
  anexo21Y22Rmf2026SistemasDeMedicion: [360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372],
  anexo21Y22Rmf2026SGM: [376, 377, 379, 380, 381, 382, 383, 384, 385, 386],
  anexo21Y22Rmf2026ProgramaInformatico: [390, 391, 392, 393, 394, 395, 396, 397, 398],
  anexo21Y22Rmf2026EvidenciasFotograficas: [402, 403, 404, 405],
  anexo21Y22Rmf2026Certificado: [409],
  // Dictamen de Diseño
  dictamenDeDisenoDocumentos: [168, 169, 170, 171, 172, 173, 174, 175, 176, 177],
  dictamenDeDisenoPlanos: [183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204],
  // NOM-016-CRE-2016
  nom016InformacionGeneral: [210, 211, 212, 213, 214, 215],
  nom016Documentacion: [219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229],
  // Inspeccion anexo 30 y 31 año 2024 para transporte o distribucion
  inspeccion30Y31Ano2024DatosGenerales: [235, 236, 237, 238, 239, 240],
  inspeccion30Y31Ano2024SistemasDeMedicion: [246, 247, 248, 249, 250],
  inspeccion30Y31Ano2024SGM: [256, 257, 258, 259, 260, 261],
  inspeccion30Y31Ano2024ProgramaInformatico: [267, 268, 269, 270, 271, 272, 273],
  inspeccion30Y31Ano2024Politicas: [279],

  transporteAnexo21Y22Rmf2026DatosGenerales2026: [410, 411, 412, 413, 414, 415, 416, 417],
  transporteAnexo21Y22Rmf2026SistemasDeMedicion2026: [418, 419, 420, 421, 422, 423, 424, 425, 426],
  transporteAnexo21Y22Rmf2026SistemasDeMedicion2026DocumentosComplementarios: [427, 428, 429, 430, 431, 432],
  transporteAnexo21Y22Rmf2026SGM2026: [433, 434, 435, 436, 437, 438, 439, 440],
  transporteAnexo21Y22Rmf2026ProgramaInformatico2026: [441, 442, 443, 444, 445, 446, 447, 448, 449],
  transporteAnexo21Y22Rmf2026Certificado2026: [450],

  distribucionAnexo21Y22Rmf2026DatosGenerales2026: [451, 452, 453, 454, 455, 456, 457, 458],
  distribucionAnexo21Y22Rmf2026SistemasDeMedicion2026: [459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471],
  distribucionAnexo21Y22Rmf2026SGM2026: [472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482],
  distribucionAnexo21Y22Rmf2026ProgramaInformatico2026: [483, 484, 485, 486, 487, 488, 489, 490, 491],
  distribucionAnexo21Y22Rmf2026Certificado2026: [492],

  comercializadoraAnexo21Y22Rmf2026DatosGenerales2026: [493, 494, 495, 496, 497, 498, 499, 500],
  comercializadoraAnexo21Y22Rmf2026ProgramaInformatico2026: [501, 502, 503, 504, 505, 506, 507, 508, 509],
  comercializadoraAnexo21Y22Rmf2026Certificado2026: [510],
};

export default titlesByCategory;
